.Main {
	--aspect: 16/9;
	position: relative;
	aspect-ratio: var(--aspect);
	/*opacity: 0;*/
	/*transition: opacity 250ms linear;*/
}

.Main.Loaded {
	opacity: 1;
}

.Main.Fill {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	aspect-ratio: unset;
}

.Img {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: contain;
}

.Main.Cover .Img {
	object-fit: cover;
}
